/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/tooltip/tooltip';
import * as i2 from '@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config';
import * as i3 from '@angular/router';
import * as i4 from '@angular/common';
import * as i5 from '../../../app/menu/menu.component';
import * as i6 from '../../../app/menu/menu.service';
import * as i7 from '../../../app/authentication/authentication';
import * as i8 from '../../../app/config/app.config';
const styles_MenuComponent:any[] = ([] as any[]);
export const RenderType_MenuComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_MenuComponent,data:{}});
function View_MenuComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),8,'a',[['placement',
      'right']],[[8,'id',0],[1,'target',0],[8,'href',4]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.onMenuClicked((<any>_v.parent).context.$implicit.Title)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,
      [i0.ElementRef,i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,
          i2.NgbTooltipConfig,i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,
          'ngbTooltip']},(null as any)),i0.ɵdid(671744,[[2,4]],0,i3.RouterLinkWithHref,
      [i3.Router,i3.ActivatedRoute,i4.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n                '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),[[1,'class',0]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','span-gpis']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    const currVal_3:any = 'right';
    const currVal_4:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,1,0,currVal_3,currVal_4);
    const currVal_5:any = (<any>_v.parent).context.$implicit.Url;
    _ck(_v,2,0,currVal_5);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Id;
    const currVal_1:any = i0.ɵnov(_v,2).target;
    const currVal_2:any = i0.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_6:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,4,0,currVal_6);
    const currVal_7:any = (<any>_v.parent).context.$implicit.Title;
    _ck(_v,7,0,currVal_7);
  });
}
function View_MenuComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),7,'a',[['href',
      '#'],['placement','right']],[[8,'id',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.openMenuList((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,[i0.ElementRef,
      i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,i2.NgbTooltipConfig,
      i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,'ngbTooltip']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n                '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'i',([] as any[]),[[1,'class',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','span-gpis']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['',''])),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵand(0,
          (null as any),(null as any),0))],(_ck,_v) => {
    const currVal_1:any = 'right';
    const currVal_2:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Id;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,3,0,currVal_3);
    const currVal_4:any = (<any>_v.parent).context.$implicit.Title;
    _ck(_v,6,0,currVal_4);
  });
}
function View_MenuComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),15,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1720320,
      (null as any),2,i3.RouterLinkActive,[i3.Router,i0.ElementRef,i0.Renderer2,i0.ChangeDetectorRef],
      {routerLinkActive:[0,'routerLinkActive']},(null as any)),i0.ɵqud(603979776,3,
      {links:1}),i0.ɵqud(603979776,4,{linksWithHrefs:1}),i0.ɵpad(1),(_l()(),i0.ɵted((null as any),
      ['\n                    '])),(_l()(),i0.ɵeld(16777216,(null as any),(null as any),
      8,'a',[['placement','right']],[[8,'id',0],[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,8).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.onMenuClicked(_v.context.$implicit.Title)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,
      [i0.ElementRef,i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,
          i2.NgbTooltipConfig,i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,
          'ngbTooltip']},(null as any)),i0.ɵdid(671744,[[4,4],[2,4]],0,i3.RouterLinkWithHref,
      [i3.Router,i3.ActivatedRoute,i4.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n                        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),[[1,'class',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
          'span-gpis']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n                    '])),
      (_l()(),i0.ɵted((null as any),['\n                ']))],(_ck,_v) => {
    const currVal_0:any = _ck(_v,4,0,'active');
    _ck(_v,1,0,currVal_0);
    const currVal_4:any = 'right';
    const currVal_5:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = _v.context.$implicit.Url;
    _ck(_v,8,0,currVal_6);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.Id;
    const currVal_2:any = i0.ɵnov(_v,8).target;
    const currVal_3:any = i0.ɵnov(_v,8).href;
    _ck(_v,6,0,currVal_1,currVal_2,currVal_3);
    const currVal_7:any = _v.context.$implicit.IconClass;
    _ck(_v,10,0,currVal_7);
    const currVal_8:any = _v.context.$implicit.Title;
    _ck(_v,13,0,currVal_8);
  });
}
function View_MenuComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),22,'ul',[['class',
      'nav nav-pills nav-stacked side-navigation']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),19,'li',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
          (null as any),0,i4.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
              i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod({'menu-list':0,
          'nav-active':1}),i0.ɵdid(1720320,(null as any),2,i3.RouterLinkActive,[i3.Router,
          i0.ElementRef,i0.Renderer2,i0.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i0.ɵqud(603979776,1,{links:1}),i0.ɵqud(603979776,2,{linksWithHrefs:1}),
      i0.ɵpad(1),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_MenuComponent_2)),i0.ɵdid(16384,
          (null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n\n            '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_3)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n\n            '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),4,'ul',[['class','child-list'],
          ['style','display: none;padding-left:10px;']],[[4,'display',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n                '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_MenuComponent_4)),i0.ɵdid(802816,(null as any),0,i4.NgForOf,
          [i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),
          i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,4,0,_v.context.$implicit.SubItems,_v.context.$implicit.Open);
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _ck(_v,8,0,'active');
        _ck(_v,5,0,currVal_1);
        const currVal_2:boolean = !_v.context.$implicit.SubItems;
        _ck(_v,11,0,currVal_2);
        const currVal_3:any = _v.context.$implicit.SubItems;
        _ck(_v,14,0,currVal_3);
        const currVal_5:any = _v.context.$implicit.SubItems;
        _ck(_v,19,0,currVal_5);
      },(_ck,_v) => {
        const currVal_4:any = (_v.context.$implicit.Open? 'block': 'none');
        _ck(_v,16,0,currVal_4);
      });
}
export function View_MenuComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),10,'div',[['style',
      'margin-left:-30px;']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'h3',[['class','navigation-title']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      ['Packaging Information Tool / '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      1,'span',[['style','color: whitesmoke']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),
      i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_1)),
      i0.ɵdid(802816,(null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i5.MenuComponent = _v.component;
    const currVal_1:any = _co.menuItems;
    _ck(_v,9,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.MenuComponent = _v.component;
    const currVal_0:any = _co.appVersion;
    _ck(_v,5,0,currVal_0);
  });
}
export function View_MenuComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'menu',([] as any[]),
      (null as any),(null as any),(null as any),View_MenuComponent_0,RenderType_MenuComponent)),
      i0.ɵprd(512,(null as any),i6.MenuService,i6.MenuService,[i7.Authentication]),
      i0.ɵdid(114688,(null as any),0,i5.MenuComponent,[i6.MenuService,i8.AppConfig],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const MenuComponentNgFactory:i0.ComponentFactory<i5.MenuComponent> = i0.ɵccf('menu',
    i5.MenuComponent,View_MenuComponent_Host_0,{},{selectedMenu:'selectedMenu'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/menu/menu.component.ngfactory.ts